/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Divider,
  Avatar,
  Tooltip
} from "@material-ui/core";

import viewer_config from "../components/Config/viewer_config";
import document_config from "../components/Config/document_config";
import table_config from "../components/Config/table_config";
import image_config from "../components/Config/image_config";
import initialState from "../../../state_management/initialState";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
  //   maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const styles = (theme) => ({
  location_button: {
    minWidth: "25px",
    height: "25px",
    padding: "3px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: "3px",
    margin: "5px",
    cursor: "pointer",
  },
});

class Summary extends Component {
  state = {};

  getSelectedStatus = () => {
    let status = false;

    let iu_record_id = this.props.record.iu_record_id;
    if (this.props.selected_record === iu_record_id) {
      status = true;
    } else {
      status = false;
    }

    return status;
  };

  getViewerConfig = () => {
    let type = this.props.record.iu_record_src_info.iu_content_type.type;
    let sub_type = this.props.record.iu_record_src_info.iu_content_type
      .sub_type;

    let viewer_index = viewer_config.findIndex(
      (viewer) =>
        viewer.type.includes(type) && viewer.sub_type.includes(sub_type)
    );
    let view_config = viewer_config[viewer_index];

    return view_config;
  };

  isDrlRequired = () => {
    let view_config = this.getViewerConfig();
    console.log("View Config :", view_config);

    let sub_type = this.props.record.iu_record_src_info.iu_content_type
      .sub_type;
    console.log("Sub Type :", sub_type);
    if (sub_type === "txt") {
      return false;
    }

    return view_config.drl_required;
  };

  getAvatar = () => {
    let view_config = this.getViewerConfig();
    console.log("Viewer Config : ", view_config);
    let type = this.props.record.iu_record_src_info.iu_content_type.type;
    let sub_type = this.props.record.iu_record_src_info.iu_content_type
      .sub_type;

    let avatar;
    if (type === "DATA") {
      //see in document config
      let viewer_index = document_config.findIndex((viewer) => viewer.type.includes(type) && viewer.sub_type.includes(sub_type));
      if (viewer_index !== -1) {
        view_config = document_config[viewer_index];
      }
      //see in table config
      else {
        viewer_index = table_config.findIndex((viewer) => viewer.type.includes(type) && viewer.sub_type.includes(sub_type));
        if (viewer_index !== -1) {
          view_config = table_config[viewer_index];
        }
      }

      
      let image_viewer_index = image_config.findIndex((viewer) => viewer.type.includes(type) && viewer.sub_type.includes(sub_type));
      if(image_viewer_index !== -1){
        view_config = image_config[image_viewer_index]
      }
    }

    // if (type === 'TABLE') {
    //     let viewer_index = table_config.findIndex(viewer =>  viewer.type.includes(type) && viewer.sub_type.includes(sub_type))
    //     view_config = table_config[viewer_index]
    // }
    avatar = view_config.avatar;
    return React.createElement(avatar, { disabled: false });
  };

  generateCardContent = () => {
    let wv_fields;
    let file_name;
    if (this.props.record.grouped === false) {
      wv_fields = this.props.record.wv_field_list;
      file_name = this.props.record.source_link.src_file_name
    } else {
      console.log("Location Index: ", this.props.location_index);
      console.log("Record :", this.props.record);
      console.log(
        "Record Location:",
        this.props.record.group[this.props.location_index]
      );
      if (this.getSelectedStatus() === true) {
        wv_fields = this.props.record.group[this.props.location_index].wv_field_list;
      } else {
        wv_fields = this.props.record.group[0].wv_field_list;
      }

      file_name = this.props.record.group[0].source_link.src_file_name
    }

    let fields = wv_fields.map((field) => {
      return (
        <div>
          <Typography variant="caption" color="primary">
            {field.name.toUpperCase()}
          </Typography>
          <div style={{ width: "100%", whiteSpace: "nowrap" }}>
            <Box
              component="div"
              my={0}
              textOverflow="ellipsis"
              overflow="hidden"
              dangerouslySetInnerHTML = {{__html: field.value.text}}
            >
              {/* {field.value.text} */}
            </Box>
          </div>
        </div>
      );
    });
    let file_name_block = null

    if (file_name) {
      file_name_block = <div style = {{marginTop : '15px', borderTop : '1px solid rgba(0,0,0,0.12)'}}>
      <Typography variant="caption" color="textSecondary">
        FILE NAME
      </Typography>
      <div style={{ width: "100%", whiteSpace: "nowrap" }}>
        <Box
          component="div"
          my={0}
          textOverflow="ellipsis"
          overflow="hidden"
          style = {{color : 'rgba(0,0,0,0.60)'}}
        >
          <em>{file_name}</em>
        </Box>
      </div>
    </div>
    }
    return [fields, file_name_block];
  };

  displayLocation = () => {
    const { classes } = this.props;
    let type = this.props.record.iu_record_src_info.iu_content_type.type;
    let shouldDisplayLocation = ( type === 'BOT' ? false : true ) ;
    let label =
      this.props.record.iu_record_src_info.iu_record_nav_info.location
        .annotation || "Location";
    let value = this.props.record.iu_record_src_info.iu_record_nav_info.location
      .position;
    return (
      <Fragment>
        {
          shouldDisplayLocation && (
            <div style={{ marginTop: "5px" }}>
            <Typography
              style={{ fontSize: "11px" }}
              variant="caption"
              color="textSecondary"
            >
              {label.toUpperCase()}
            </Typography>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              {this.props.record.grouped ? (
                this.renderLocation()
              ) : (
                <div
                  className={classes.location_button}
                  style={{
                    backgroundColor:
                      this.getSelectedStatus() === true ? "#2296f3" : null,
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "11px",
                      cursor: "pointer",
                      color:
                        this.getSelectedStatus() === true
                          ? "#FFFFFF"
                          : "rgba(0,0,0,0.75)",
                    }}
                    variant="caption"
                  >
                    {
                      this.props.record.iu_record_src_info.iu_record_nav_info
                        .location.position
                    }
                  </Typography>
                </div>
              )}
            </div>
          </div>
          )
        }
      </Fragment>
    );
  };

  renderLocation = () => {
    const { classes } = this.props;
    let location = this.props.record.group.map((record, i) => {
      return (
        <div
          className={classes.location_button}
          style={{
            backgroundColor:
              this.getSelectedStatus() === true &&
              this.props.location_index === i
                ? "#2296f3"
                : null,
          }}
          onClick={() => {
            if (this.getSelectedStatus() === true) {
              this.props.setLocation(i);
            }
          }}
        >
          <Typography
            style={{
              fontSize: "11px",
              cursor: "pointer",
              color:
                this.getSelectedStatus() === true &&
                this.props.location_index === i
                  ? "#FFFFFF"
                  : "rgba(0,0,0,0.75)",
            }}
            variant="caption"
          >
            {
              this.props.record.group[i].iu_record_src_info.iu_record_nav_info
                .location.position
            }
          </Typography>
        </div>
      );
    });

    return location;
  };

  getRank = () => {
      let rank
      if (this.getSelectedStatus() === true) {
        if (this.props.record.grouped === true) {
          rank = this.props.record.group[this.props.location_index].order
        } else {
          rank = this.props.record.order
        }
      } else {
        if (this.props.record.grouped === true) {
          rank = this.props.record.group[0].order
        } else {
          rank = this.props.record.order
        }
      }

      let confidence
      if (this.getSelectedStatus() === true) {
        if (this.props.record.grouped) {
          confidence = this.props.record.group[this.props.location_index].score
        } else {
          confidence = this.props.record.score
        }
      } else {
        if (this.props.record.grouped) {
          confidence = this.props.record.group[0].score
        } else {
          confidence = this.props.record.score
        }
      }

      confidence = Number(confidence * 100).toFixed(2)

      return (
        <HtmlTooltip 
        title = {
          <div>
              <div>
                  <div style = {{width  : '100%', padding : '5px', display : 'flex', flexDirection : 'column'}}>
                      <Typography style = {{flexGrow : 1}} variant = 'caption' color = "textSecondary">Rank: {rank}</Typography>
                      <Typography style = {{flexGrow : 1}} variant = 'caption' color = "textSecondary">Confidence: {confidence}</Typography>
                  </div>
              </div>
          </div>
        }>
          <Avatar variant = 'square' style = {{backgroundColor : "#2296f3"}}>
            <Typography variant = 'body2'>{rank}</Typography>
          </Avatar>
        </HtmlTooltip>
      )
  }

  displaySource = () => {
    let navigation = []

    // if (this.props.record.grouped === false) {
    //   navigation = this.props.record.iu_record_src_info.iu_record_nav_info.source
    // } else {
    //   navigation = this.props.record.iu_record_src_info.iu_record_nav_info.source
    // }
    navigation = this.props.record.iu_record_src_info.iu_record_nav_info.source
    return (
      <div style = {{width : '100%', borderTop : '1px solid rgba(0,0,0,0.12)'}}>
        <Typography variant = 'overline' color = 'textSecondary'>
          Source
        </Typography>
        {navigation.map(level => {
          return (
            <div style = {{marginBottom : '10px'}}>
              <Typography variant = 'caption' color = 'textSecondary' display = 'block'>{level.annotation}</Typography>
              <Typography variant = 'body2' color = 'textSecondary' display = 'block'>{level.link}</Typography>
            </div>
          )
        })}
        <Divider/>
      </div>
    )
  }

  displayAttachmentButton = () => {
    if (this.props.re_attach) {
      let show_attachment_button = false
      if (this.props.record.grouped === false) {
        if (this.props.record.group[this.props.location_index].iu_record_src_info.iu_content_type.type === 'DATA') {
          show_attachment_button = true
        }
      } else {
        if (this.props.record.iu_record_src_info.iu_content_type.type === 'DATA') {
          show_attachment_button = true
        }
      }

      if (show_attachment_button) {
        console.log("SEARCH :: Attachment Options : ", this.props.attach_options)
      }
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <ThemeProvider theme={blue_theme}>
        <Card
          key={this.props.record.iu_record_id}
          style={{
            marginBottom: "5px",
            padding: 0,
            backgroundColor:
              this.getSelectedStatus() === true ? "#FFFFFF" : "#f2f2f2",
            opacity: this.getSelectedStatus() === true ? "1.0" : "0.85",
          }}
          variant={this.getSelectedStatus() === true ? "elevated" : "outlined"}
          elevation={3}
          onClick={() => {
            return this.props.selectRecord(
              this.props.record,
              this.isDrlRequired(),
              this.props.record.iu_record_src_info.iu_content_type.sub_type,
              this.props.record.source_link.file_id
            );
          }}
        >
          <CardHeader
            style={{ margin: "10px", padding: 0 }}
            avatar={<div>{this.getAvatar()}</div>}
            subheader={this.props.record.iu_key.user_friendly_name}
            // subheader={
            //   this.getViewerConfig().viewer[0].toUpperCase() +
            //   this.getViewerConfig().viewer.slice(1)
            // }
            // title={this.props.record.iu_record_id}
            // titleTypographyProps={{
            //   style: {
            //     fontWeight: "bold",
            //   },
            //   color: "primary",
            // }}
            subheaderTypographyProps={{
              color: "textSecondary",
            }}
            action = {this.getRank()}
          />
          <CardContent>
            {this.generateCardContent()}
            <Divider style={{ marginTop: "5px" }} />
            {this.displayLocation()}
            {this.displaySource()}
            {/* {this.displayAttachmentButton()} */}
          </CardContent>
        </Card>
      </ThemeProvider>
    );
  }
}

export default withStyles(styles)(Summary);
